<div class="modal-header">
        <button type="button" class="btn-close" (click)="bsModalRef.hide()" aria-label="Close"><i class="feather x"></i></button>
        <h4 class="modal-title" id="myModalLabel">Preferences</h4>
    </div>
    
    <div class="modal-body">
            <h4>Notifications</h4>
            <div class="row">
                <div class="col-md-12">
                <form>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" [checked]="has_web_push_enabled" (click)="toggleWebPushNotifications()" class="form-check-input" id="exampleCheck1">
                            Enable Web Push Notifications
                        </label>
                    </div>
                </form>
                </div>
            </div>
            <!-- <hr>
            <div class="my-account-change-password">
                <button class="btn btn-primary btn-lg pull-left">Save preferences</button>
                <button class="btn btn-default btn-lg pull-right">Cancel</button>
                <br style="clear:both">
            </div> -->
            <!-- <hr> -->
    </div>
    